import {HEALTH_CONDITIONS} from '../constants';

export const saveHeartCondition = condition => ({
  type: HEALTH_CONDITIONS.SET_HEALTH_CONDITIONS,
  condition
});

export const resetHeartCondition = () => ({
  type: HEALTH_CONDITIONS.RESET_HEALTH_CONDITIONS
});
